import type { ReactNode } from 'react';
import { useRouter } from 'next/router';
import { GenericEventsBiLoggerProvider, PageContextProvider } from '@wix/data-tools-generic-events';
import { orionBiReporter } from './bi-logger';
import { biPageName } from './bi-page-name';

// orion-web is a Next.js app (not yoshi-flow-bm), so the generic-events library
// can't get a logger from `useBi()`. We inject the same web-bi-logger the src:172
// events already use, and resolve `pageName` through the shared cross-surface
// vocabulary in `bi-page-name.ts` — the same names iOS and Android report for these
// screens. (It used to be the Next.js file route, so web said `index` where native
// said `catch_up`.) The per-call src:172 page_name values still ride along in each
// event's additionalFields (see use-generic-bi).
export const GenericEventsProviders = ({ children }: { children: ReactNode }) => {
  const router = useRouter();
  return (
    <GenericEventsBiLoggerProvider value={orionBiReporter}>
      <PageContextProvider pageContext={{ pageName: biPageName(router.pathname, router.query) }}>
        {children}
      </PageContextProvider>
    </GenericEventsBiLoggerProvider>
  );
};
